var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Translate, t } from "../../I18N";
import api from "../../utils/api";
import { Icon } from "../../UI";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { notify } from "../../Notifications/actions/notificationsActions";
import { RequestParams } from "../../utils/RequestParams";

class ContactForm extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { name: '', email: '', message: '' };
    this.submit = this.submit.bind(this);
  }

  onChange(key, e) {
    const changedData = {};
    changedData[key] = e.target.value;
    this.setState(changedData);
  }

  async submit(e) {
    e.preventDefault();
    await api.post('contact', new RequestParams(this.state));
    this.props.notify(t('System', 'Message sent', null, false), 'success');
    this.setState({ name: '', email: '', message: '' });
  }

  render() {
    return /*#__PURE__*/(
      _jsx("form", { onSubmit: this.submit, className: "contact-form" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "form-group" }, void 0, /*#__PURE__*/
      _jsx("label", { className: "form-group-label", htmlFor: "name" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Name")
      ), /*#__PURE__*/
      _jsx("input", {
        required: true,
        name: "name",
        className: "form-control",
        onChange: this.onChange.bind(this, 'name'),
        value: this.state.name }
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "form-group" }, void 0, /*#__PURE__*/
      _jsx("label", { className: "form-group-label", htmlFor: "email" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Email")
      ), /*#__PURE__*/
      _jsx("input", {
        required: true,
        name: "email",
        className: "form-control",
        onChange: this.onChange.bind(this, 'email'),
        value: this.state.email }
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "form-group" }, void 0, /*#__PURE__*/
      _jsx("label", { className: "form-group-label", htmlFor: "message" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Message")
      ), /*#__PURE__*/
      _jsx("textarea", {
        required: true,
        name: "message",
        className: "form-control",
        onChange: this.onChange.bind(this, 'message'),
        value: this.state.message }
      )
      ), /*#__PURE__*/
      _jsx("button", { type: "submit", className: "btn btn-success" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "paper-plane" }), "\xA0", /*#__PURE__*/

      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Send")
      )
      )
      ));

  }
}





function mapDispatchToProps(dispatch) {
  return bindActionCreators({ notify }, dispatch);
}

export { ContactForm };
export default connect(null, mapDispatchToProps)(ContactForm);